import React, { useEffect, useState } from 'react'
import Appliances from './Appliances'
import General from './General'
import Heating from './Heating'

import { IonIcon } from '@ionic/react'
import { ConsumptionTimeFrame, Report } from '@vae/server/dist/client'
import { arrowDown, arrowUp } from 'ionicons/icons'
import { useTranslation } from 'react-i18next'

interface Props {
	cardName: string
	observedReport: Report
	previousReport: Report | undefined | null
	averages:
		| {
				id: number
				personCount: number
				from: string
				to: string
				totalConsumption: number
				totalCO2: number
				heatingCO2: number
				timeframe: ConsumptionTimeFrame
				totalHeatingConsumption: number
				// eslint-disable-next-line no-mixed-spaces-and-tabs
		  }
		| null
		| undefined
}

type ColorOptions = 'red' | 'green'

const getColorFromString = (str: ColorOptions) => {
	return str === 'red' ? '#b21672' : '#52ae32'
}

const ReportCard = (props: Props) => {
	const { observedReport, previousReport, averages } = props
	const { t } = useTranslation('pages_monthlyReport')

	const state = {
		Yleistilanne: t('yleistilanne'),
		Lämmitys: t('lammitys'),
		Kodinkoneet: t('kodinkoneet'),
	}

	const [cardState, setCardState] = useState(props.cardName)

	const [observedValue, setObservedValue] = useState(0)
	const [arrowColor, setArrowColor] = useState<ColorOptions>('green')
	const [arrowStatus, setArrowStatus] = useState(arrowDown)

	const handleChange = () => {
		if (!observedReport) return

		switch (props.cardName) {
			case 'general':
				setCardState('Yleistilanne')
				setObservedValue(observedReport.totalConsumption)
				setArrowStatus(
					previousReport && observedReport.totalConsumption < previousReport.totalConsumption
						? arrowDown
						: arrowUp
				)
				setArrowColor(
					previousReport && observedReport.totalConsumption < previousReport.totalConsumption
						? 'green'
						: 'red'
				)
				break
			case 'heating':
				setCardState('Lämmitys')
				setObservedValue(observedReport.heatingConsumption || 0)
				setArrowStatus(
					previousReport && observedReport.heatingConsumption < previousReport.heatingConsumption
						? arrowDown
						: arrowUp
				)
				setArrowColor(
					previousReport && observedReport.heatingConsumption < previousReport.heatingConsumption
						? 'green'
						: 'red'
				)
				break
			case 'appliances':
				setCardState('Kodinkoneet')
				setObservedValue(observedReport.applianceConsumption || 0)
				setArrowStatus(
					previousReport &&
						observedReport.applianceConsumption < previousReport.applianceConsumption
						? arrowDown
						: arrowUp
				)
				setArrowColor(
					previousReport &&
						observedReport.applianceConsumption < previousReport.applianceConsumption
						? 'green'
						: 'red'
				)
				break
			default:
				break
		}
	}

	useEffect(() => {
		handleChange()
	}, [props.cardName])

	return (
		<div className='report'>
			<div className='title text-text-dark dark:text-white tracking-wide'>
				{state[cardState as keyof typeof state]}
			</div>

			{cardState !== 'Yleistilanne' ? (
				<div className='main-value'>
					<span>
						<IonIcon icon={arrowStatus} style={{ color: getColorFromString(arrowColor) }} />
					</span>
					<span className='value tracking-wide font-semibold text-brand-primary-100-light dark:text-brand-primary-100-dark'>
						{observedValue}
					</span>
					<span className='text-lg font-normal text-text-grey-200 dark:text-text-grey-100'>
						{' '}
						kwh
					</span>
				</div>
			) : null}

			<div className='card mt-2'>
				{cardState === 'Yleistilanne' ? (
					<General
						observedReport={observedReport}
						previousReport={previousReport}
						averages={averages}
					/>
				) : null}
				{cardState === 'Lämmitys' ? (
					<Heating
						observedReport={observedReport}
						previousReport={previousReport}
						averages={averages}
					/>
				) : null}
				{cardState === 'Kodinkoneet' ? (
					<Appliances
						observedReport={observedReport}
						previousReport={previousReport}
						averages={averages}
					/>
				) : null}
			</div>
		</div>
	)
}
export default ReportCard
